import { usePermissions } from 'contexts';
import React, { useEffect, useState } from 'react';
import ReportService from 'services/reports.service';
import { openModal } from 'store/modals/modals.slice';
import {
  getPoliciesThunk,
  getPolicyThunk,
} from 'store/policies/policies.thunks';

import events from '../../../shared/constants/events';
import { MODAL_POLICY } from '../../../shared/constants/modals';
import * as utils from '../../../shared/utils';
import { useAppDispatch, useAppSelector } from '../../../store';
import { vocabulary } from '../../../vocabulary/german';
import { CreateButton } from '../../buttons/create-button/create-button';
import { EntityPanel } from '../../panels/entity-panel/entity-panel';
import { Container } from '../../template/container/container';
import { NotFoundMessage } from '../../template/not-found-message/not-found-message';
import { PageHeader } from '../../template/page-header/page-header';
import { Spinner } from '../../template/spinner/spinner';

const PrioritiesPage = () => {
  const dispatch = useAppDispatch();

  const policies = useAppSelector((state) => state.policies);
  const permissions = usePermissions();
  const [isLocked, setIsLocked] = useState(false);

  const unlock = () => {
    setIsLocked(false);
  };

  useEffect(() => {
    dispatch(getPoliciesThunk());
    document.body.addEventListener(events.UNLOCK.name, unlock);

    return document.body.removeEventListener(events.UNLOCK.name, unlock);
  }, [dispatch]);

  const handleAddPriority = (id: number): void => {
    if (id) {
      dispatch(getPolicyThunk(id));
      dispatch(openModal({ name: MODAL_POLICY }));
    }
  };

  const downloadPoliciesReport = (type) => {
    setIsLocked(true);
    const reportsService = new ReportService();
    reportsService.downloadPoliciesReport(type);
  };

  const renderEntityPanels = () => {
    if (policies.isGetPoliciesThunkPending) {
      return <Spinner />;
    }

    if (!policies.list.length) {
      return (
        <NotFoundMessage
          message={`Nicht gefunden: Ambitionen konnten nicht gefunden werden.`}
        />
      );
    }

    return (
      <div className={'entities-list entities-list_priorities'}>
        {policies.list.map((policy, index) => (
          <div className={'row policies-row'} key={index}>
            <div className={'col'}>
              <EntityPanel isFixed title={policy.title} id={policy.id} />
            </div>
            <div className={'col'}>
              {policy.Priorities &&
              !utils.helpers.isObjectEmpty(policy.Priorities) ? (
                <>
                  {policy.Priorities.map((priority, priorityIndex) => (
                    <EntityPanel
                      key={priorityIndex}
                      title={priority.title}
                      id={priority.id}
                      onClick={() => handleAddPriority(policy.id)}
                    />
                  ))}
                  {permissions.permissions.createNew === true && (
                    <CreateButton
                      text={vocabulary.buttons.addPriority}
                      onClick={() => handleAddPriority(policy.id)}
                    />
                  )}
                </>
              ) : (
                <>
                  <NotFoundMessage
                    message={`Nicht gefunden: Ambitionen konnten nicht gefunden werden`}
                  />
                  {permissions.permissions.createNew === true && (
                    <CreateButton
                      text={vocabulary.buttons.addPriority}
                      onClick={() => handleAddPriority(policy.id)}
                    />
                  )}
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className={'page-content'}>
        <PageHeader
          title={vocabulary.labels.priorities}
          btnTextDocx={vocabulary.buttons.reports.downloadReportDocx}
          downloadReport={downloadPoliciesReport}
          btnText={vocabulary.buttons.reports.downloadReportPdf}
        />

        <Container>{renderEntityPanels()}</Container>
      </div>
      {isLocked && (
        <Spinner isFullSize message={vocabulary.preloader.waitForReport} />
      )}
    </React.Fragment>
  );
};

export default PrioritiesPage;
